// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2829":"5ac19140","3729":"c2949eab"}[chunkId] + ".chunk.css";
};